import { createQuery } from "react-query-kit";
import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import WardModel from "../../models/masters/ward-model";
import axios, { AxiosError } from "axios";

const url = getEndPoint(API_END_POINT.MASTER) +"/api/Ward/GetAllWard";// //{/api/Category/GetAllCategory}`)  //// "https://localhost:7054/api/Category/GetAllCategory";
export const useGetWards = createQuery<
  WardModel[],
  null,
  AxiosError
>({
  queryKey: ["keyWardlist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});